import React from 'react';
import { DigitalSignSuccess } from '../../components/contracts/financial-details/bank-account-section/edit-view/sepa-download-view/digita-sign-success/DigitalSignSuccess';

export const DigitalSignSuccessPage: React.FC = () => <DigitalSignSuccess />;
